module.exports = "<div fxLayout=\"row\" fxLayoutAlign=\"center center\" fxFlexFill>\n    <span>{{contractId}}</span>\n  </div>"